import { Result } from "antd";
import i18n from "@/utils/i18n";
interface PendingApprovalStateProps {
  /**
   * Kayıt onaylı ama eğitim henüz yayınlanmadı. Bu durumda "başvurun onay
   * bekliyor" demek yanlış: onay tamam, beklenen yöneticinin planlamayı
   * yayınlaması.
   */
  awaitingPublish?: boolean;
}

export function PendingApprovalState({ awaitingPublish = false }: PendingApprovalStateProps) {
  const prefix = awaitingPublish ? "awaitingPublishState" : "pendingApprovalState";
  return (
    <Result
      status="info"
      title={i18n.t(`${prefix}.title`)}
      subTitle={i18n.t(`${prefix}.subTitle`)}
    />
  );
}
